import { environment } from '../../environments/environment';
import { SummaryQuoteModel } from '../core';

const digitsOnly = (s?: string | null): string => {
  return (s ?? '').replace(/\D/g, '');
};

const normalizeGender = (g?: string | null): 'male' | 'female' | undefined => {
  if (!g) {
    return undefined;
  }
  const v = g.trim().toLowerCase();
  if (v.startsWith('m')) {
    return 'male';
  }
  if (v.startsWith('f')) {
    return 'female';
  }
  return undefined;
};

const parseIncome = (s?: string | null): number | undefined => {
  if (!s) {
    return undefined;
  }
  const cleaned = s.replace(/[^0-9.]/g, '');
  const n = Number(cleaned);
  if (Number.isFinite(n)) {
    return Math.round(n);
  }
  return undefined;
};

const formatDob = (dob: string): string | null => {
  const date = new Date(dob);
  if (isNaN(date.getTime())) {
    return null;
  }
  return date.toISOString().split('T')[0]; // YYYY-MM-DD
};

export function buildJetEdeUrl(model: SummaryQuoteModel, base = environment.jetUrl): string {
  const url = new URL('/apply-deeplinking', base);
  const q = url.searchParams;

  if (model.firstName) {
    q.set('people[primary][first_name]', model.firstName.trim());
  }

  if (model.lastName) {
    q.set('people[primary][last_name]', model.lastName.trim());
  }

  if (model.dob) {
    const dobFormatted = formatDob(model.dob.trim());
    if (dobFormatted) {
      q.set('people[primary][dob]', dobFormatted);
    }
  }

  const g = normalizeGender(model.gender) ?? model.gender?.trim();
  if (g) {
    q.set('people[primary][gender]', g);
  }

  const hhSize = 1 + (Array.isArray(model.dependents) ? model.dependents.length : 0);
  q.set('household_size', String(hhSize));

  const income = parseIncome(model.annualIncome);
  if (income !== undefined) {
    q.set('household_income', String(income));
  }

  if (model.planID) {
    q.set('plan_hios_id', model.planID.trim());
  }

  if (model.quoteID) {
    q.set('enrollment_id', model.quoteID.trim());
  }

  if (model.email) {
    q.set('email', model.email.trim());
  }

  if (model.county) {
    q.set('county', model.county.trim());
  }

  if ((model as any).street) {
    q.set('street_address', String((model as any).street).trim());
  }

  if ((model as any).street2) {
    q.set('street_address2', String((model as any).street2).trim());
  }

  if ((model as any).city) {
    q.set('city', String((model as any).city).trim());
  }

  if ((model as any).state) {
    q.set('state', String((model as any).state).trim());
  }

  if (model.zipCode) {
    q.set('zip_code', model.zipCode.trim());
  }

  if (model.phone) {
    const phoneNum = digitsOnly(model.phone);
    if (phoneNum) {
      q.set('phone_number', phoneNum);
      q.set('phone_type', 'Mobile');
    }
  }

  console.log("Jet url", url);
  console.log("Jet url string", url.toString());
  return url.toString();
}
